import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgSuperstar = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16 7.996c-1.13.781-2.406 1.365-3.74 1.765.66 1.227 1.15 2.544 1.396 3.895-1.35-.246-2.665-.735-3.89-1.395-.4 1.332-.985 2.606-1.765 3.733l-.004-.003a12.4 12.4 0 0 1-1.025-1.794l-.476-1.147c-.095-.26-.178-.525-.258-.791-1.227.661-2.544 1.151-3.895 1.397v-.005q.188-1.014.544-1.993l.474-1.148q.178-.38.38-.748C2.405 9.362 1.128 8.778 0 7.997l.004-.004c.564-.39 1.166-.732 1.793-1.025l1.147-.476q.393-.141.793-.26c-.66-1.226-1.148-2.54-1.394-3.89l.005.002c.675.123 1.341.307 1.992.543l1.148.474q.378.178.745.377c.4-1.335.985-2.614 1.767-3.744.781 1.13 1.368 2.406 1.768 3.741 1.225-.659 2.539-1.147 3.888-1.393-.245 1.349-.733 2.663-1.392 3.888 1.333.4 2.608.986 3.736 1.766"
      />
    </svg>
  );
};
export default SvgSuperstar;
